var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "invitation-card" }, [
    _c("img", {
      staticClass: "btn",
      attrs: {
        alt: "",
        "data-clipboard-action": "copy",
        "data-clipboard-text": "flkf17001",
        src: require("@/assets/imgs/invitation-card/button.png")
      },
      on: { click: _vm.copy }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }